import { DefaultModal } from "../../../../../global/modals/material/DefaultModal";
import { getMobileOperatingSystem } from "../../../../../../lib/global/getMobileOperatingSystem";
import { useRouter } from "next/router";
import { useModalContext } from "../../../../../global/modals/ModalProvider";
import { WorkoutSuccessScheduleModalWrapper } from "./WorkoutSuccessScheduleModalWrapper";
import { WorkoutSuccessScheduleModalTitle } from "./WorkoutSuccessScheduleModalTitle";
import { WorkoutSuccessScheduleModalSubtitle } from "./WorkoutSuccessScheduleModalSubtitle";
import { WorkoutSuccessScheduleModalStoresWrapper } from "./WorkoutSuccessScheduleModalStoresWrapper";
import { StoreContainer, StoreImage } from "../../../../../global/MobileStores";
import { analyticsFunction } from "../../../../../../lib/dataAnalytics/eventListener";
import { WorkoutSuccessScheduleModalActionsWrapper } from "./WorkoutSuccessScheduleModalActionsWrapper";
import {
  AppPrimaryButton,
  AppSecondaryButton,
} from "../../../../../global/ui/buttons";

export const WorkoutSuccessScheduleModal = () => {
  const router = useRouter();
  const { closeModal } = useModalContext();

  const handleDownloadApp = () => {
    const mobileDevice = getMobileOperatingSystem();

    if (mobileDevice === "iOS") {
      void router.push("https://apps.apple.com/ie/app/pod1um/id1562663063");
      return;
    }

    void router.push(
      "https://play.google.com/store/apps/details?id=app.pod1um",
    );

    closeModal();
  };

  return (
    <DefaultModal onClose={closeModal}>
      <WorkoutSuccessScheduleModalWrapper>
        <WorkoutSuccessScheduleModalTitle>
          Workout Scheduled!
        </WorkoutSuccessScheduleModalTitle>

        <WorkoutSuccessScheduleModalSubtitle>
          Access your workout, plus much more, on the Pod1um mobile App.
          Available on both iOS & Android.
        </WorkoutSuccessScheduleModalSubtitle>

        <WorkoutSuccessScheduleModalStoresWrapper>
          <a
            href="https://play.google.com/store/apps/details?id=app.pod1um"
            target="_blank"
          >
            <StoreContainer
              onClick={() => {
                analyticsFunction({
                  event: "select_content",
                  content_type: "android",
                  item_id: `Section 0`,
                });
              }}
            >
              <StoreImage src={"/images/google-play.svg"} />
            </StoreContainer>
          </a>

          <a
            href="https://apps.apple.com/ie/app/pod1um/id1562663063"
            target="_blank"
          >
            <StoreContainer
              onClick={() => {
                analyticsFunction({
                  event: "select_content",
                  content_type: "Apple",
                  item_id: `Section 1`,
                });
              }}
            >
              <StoreImage src={"/images/app-store.svg"} />
            </StoreContainer>
          </a>
        </WorkoutSuccessScheduleModalStoresWrapper>

        <WorkoutSuccessScheduleModalActionsWrapper>
          <AppSecondaryButton className="flex-1 py-2" onClick={closeModal}>
            Continue
          </AppSecondaryButton>

          <AppPrimaryButton
            className="flex-[2] mb-3 lg:mb-0 py-2"
            onClick={handleDownloadApp}
          >
            Download the app
          </AppPrimaryButton>
        </WorkoutSuccessScheduleModalActionsWrapper>
      </WorkoutSuccessScheduleModalWrapper>
    </DefaultModal>
  );
};
